import React, { Component } from 'react'
import { Row, Field, Label, Button }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import styled from 'styled-components';
import Shubox from 'shubox'

const ButtonUpload = Button.withComponent('div').extend`
  padding: 0;
  > div {
    padding: 8px 30px;
  }
`;

const Image = styled.img`
  max-width: 250px;
  max-height: 250px;
  margin: 0 0 10px;
  border: 1px solid #ccc;
  padding: 5px;
`

const Progress = styled.div`
  height: 15px;
  position: relative;
  background: #eee;
  max-width: 250px;
  margin: 10px 0;
  border: 1px solid #777;
`

const Bar = styled.div`
  position: absolute;
  background: rgb(82, 107, 247);
  top: 0; left: 0;
  height: 100%;
  width: 0;
`

const Hint = styled.div`
  color: rgba(0,0,0,0.6);
  margin-top: 7px;
  margin-bottom: 7px;
`

class Signature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      done: true,
    }
    this.uploadButton = React.createRef()
    this.shuboxify = this.shuboxify.bind(this)
    this.removeLogo = this.removeLogo.bind(this)
  }

  shuboxify() {
    let elem = this.uploadButton.current;
    if (elem) {
      if (elem.dropzone) {
        elem.dropzone.destroy();
      }

      new Shubox(`#${this.uploadButton.current.id}`, {
        key: '368068b1-4cbb-4d84-a87c-6a273cb962df',
        previewsContainer: false,
        acceptedFiles: 'image/gif,image/png,image/jpeg',
        success: (file) => {
          this.props.onChange({
            target: {
              name: 'userEvent[invitation_logo]',
              value: file.s3url,
            }
          })
        },
      })

      elem.dropzone.on("totaluploadprogress", (progress) => {
        this.setState({ progress: progress })
      })

      elem.dropzone.on("sending", (file) => {
        this.setState({ done: false })
      })

      elem.dropzone.on("queuecomplete", (progress) => {
        this.setState({ done: true })
      });

    }
  }

  componentDidUpdate() {
    this.shuboxify()
  }

  componentDidMount() {
    this.shuboxify()
  }

  removeLogo() {
    this.props.onChange({
      target: {
        name: 'userEvent[invitation_logo]',
        value: null,
      }
    })
  }

  render() {
    const { userEvent, currentUser, onChange } = this.props
    return (
      <React.Fragment>
        <Row>
          <Field name="userEvent[signature]" error={false}>
            <Label value="Sign with your name and/or logo" required={true} />
            <TextInput value={userEvent.signature} placeholder={`Sincerely, ${currentUser.firstname} ${currentUser.lastname}`} onChange={onChange} />
          </Field>
          <Field style={{marginBottom: '35px'}} name="userEvent[invitation_logo]" error={false}>
            <Label value="Upload signature or logo image (optional)" />
              <Hint>JPG or PNG file only</Hint>
            {this.state.done ? (
              <React.Fragment>
                {userEvent.invitation_logo ? (
                  <React.Fragment>
                    <Image src={userEvent.invitation_logo} />
                    <div>
                      <ButtonUpload small style={{ marginRight: '10px' }}><div id="logo" ref={this.uploadButton}>Replace</div></ButtonUpload>
                      <Button small onClick={this.removeLogo}>Remove</Button>
                    </div>
                  </React.Fragment>
                ) : (
                  <ButtonUpload small><div id="logo" ref={this.uploadButton}>Upload</div></ButtonUpload>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div>Uploading...</div>
                <Progress><Bar style={{width: this.state.progress + '%'}} /></Progress>
              </React.Fragment>
            )}
          </Field>
        </Row>
      </React.Fragment>
    )
  }
}

export default Signature
